import './Obrigado.css';
import imagem from "./img/LogoSofie.png";
import whatsapp from "./img/whatsapp.png";
import { useEffect } from 'react';

function Obrigado() {

    const fazerRequest = (envia_dados) => {
        fetch("https://o7iuu6pxtg.execute-api.sa-east-1.amazonaws.com/prod/lead",
        {
            method: "POST",
            body: JSON.stringify(envia_dados),
        })
        .then((res) => res.json())
        .then((data) => { 
            console.log("data = ", data)
            fetch("https://iodo.digital/sofie/sofie-mailchimp.php",
            {
                method: "POST",
                body: JSON.stringify(envia_dados),
            })
            .then((res) => res.json())
            .then((sucesso) => { 
                console.log("sucesso = ", sucesso);
            })
        })
    }

    useEffect(() => {
        let url = window.location.search;
        let urlParams = new URLSearchParams(url);
        let nome = urlParams.get("nome");
        let email = urlParams.get("email");
        let telefone = urlParams.get("telefone");

        if (
        nome !== "" &&
        nome !== null &&
        telefone !== "" &&
        telefone !== null &&
        email !== "" &&
        email !== null
        ) {
            let envia_dados = {
                email: email,
                nome: nome,
                telefone: telefone,
            };
            fazerRequest(envia_dados)
        } else {
        alert("Preencha todos os campos corretamente");
        window.location.href = "/"
        }
    }, [])

    return (
        <div id="Obrigado" className="ObrigadoContainer">
            <div className="ObrigadoLeft">
                <div className="ObrigadoLogo">
                        <img className="Logo" onClick={() => window.location.href = "/"} src={imagem} alt="Sofie" />
                </div>
                <div className="ObrigadoFlex">
                    <div className="ObrigadoText">
                        Obrigado pela sua confiança! Falta pouco para você se tornar um <div className="inline red">Sofier</div>!
                    </div>
                    <div className="ObrigadoLine" />
                    <div className="ObrigadoText">
                        Aproveita e <div className="inline blue">baixe</div> o nosso APP hoje mesmo e já comece a conhecer mais a <div className="inline red">Sofie</div>
                    </div>
                    <div className="ObrigadoButton" onClick={() => {window.location.href = "https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}}>
                        <div className="ObrigadoButtonText">
                            CLIQUE AQUI
                        </div>
                    </div>
                    <a href="https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                        <img width="175px" alt="Disponível no Google Play" src="https://play.google.com/intl/pt-BR/badges/static/images/badges/pt_badge_web_generic.png" />
                    </a>
                </div>
            </div>
            <div className="ObrigadoRight">
                <div className="ObrigadoRightTop">
                    O que é a <div className="inline red">Sofie</div>:
                </div>
                <div className="ObrigadoPlayer">
                    <iframe title="youtube" width="100%" height="100%" src="https://www.youtube.com/embed/pgLzUoKFqKc" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="" />
                </div>
                <div className="ObrigadoRightBottom">
                    Ainda está com dúvidas?{" "}
                    <a href="https://api.whatsapp.com/send?phone=5511963019251">
                        <div className="inline green" style={{paddingRight: "7px"}}>
                            Contate-nos
                        </div>
                    </a> 
                    <img width="20px" alt="Whatsapp" src={whatsapp} />
                </div>
            </div>
        </div>
    );
}

export default Obrigado;